import React from 'react';
import { Flex, Text } from '../design-system';
import { displayText } from '../helpers/utils';
import PreLineText from './PreLineText';
import Tooltip from './Tooltip';

interface DescriptionToolTipProps {
  cell: { value: any };
  maxLength?: number;
}

const DescriptionToolTip = ({
  cell: { value },
  maxLength,
}: DescriptionToolTipProps) => {
  if (Array.isArray(value)) {
    return (
      <Flex flexDirection="column" justifyContent="center">
        {value.map(({ id, title }) => {
          const { text, more } = displayText(title);
          return (
            <Text pt={10} key={id}>
              <PreLineText>
                <span dangerouslySetInnerHTML={{ __html: text }} />
              </PreLineText>
              {more && <Tooltip text={title}>...</Tooltip>}
            </Text>
          );
        })}
      </Flex>
    );
  }

  const { text, more } = displayText(value, maxLength);
  return (
    value && (
      <>
        <PreLineText>
          <span dangerouslySetInnerHTML={{ __html: text }} />
        </PreLineText>
        {more && <Tooltip text={value}>...</Tooltip>}
      </>
    )
  );
};

export default DescriptionToolTip;
